import * as React from 'react';

import {Card} from 'shells/card/card';

import {CardContent} from './card-content';

import styles from './chart-card.module.css';

type Props = {
    isLoading: boolean;
    isError: boolean;
    comingSoonText?: string | null | undefined;
    content: React.ReactNode;
    banner?: React.ReactNode;
    promoStateOverlay?: React.ReactNode;
};

export function ChartCard(props: Props) {
    return (
        <div className='mb-16'>
            <Card hasBorder={true} fitHeight={true}>
                <div className={styles.container}>
                    <div className='flex flex-dir-col full-width full-height'>
                        {/* @ts-expect-error */}
                        <CardContent {...props} />
                    </div>
                    {props.promoStateOverlay}
                </div>
            </Card>
        </div>
    );
}
